import { Flex } from 'component/base/Grid';
import GlobalStyle from 'component/layout/globalStyles';
import React, { memo } from 'react';

import { Container, Main } from './styles';
import { IAppLayout } from './types';

/**
 * Layout of the total web beecastle webapp.
 * Renders Header (conditionaly), children, Drawer, ModalStack.
 *
 * @param props.children react children.
 * @param props.ChildrenOverride - a Component that will be rendered instead of children
 * @param props.globalStyle - default true - apply the global styles to the layout
 * @param props.disableHeader - greys out and disables header.
 * @param props.disableSidebar - greys out and disables app sidebar.
 * @param props.showHeader - to show the header bar and left sidebar nav.
 *   Will add left margin to container to offset width of fixed position
 *   Sidebar component.
 */
const AppLayout = ({
  children,
  globalStyle = true,
}: IAppLayout): JSX.Element => {
  return (
    <>
      {globalStyle && <GlobalStyle />}
      <Container showHeader={false}>
        <Main>
          <Flex flexDirection="row" flexGrow={1}>
            {children}
          </Flex>
        </Main>
      </Container>
    </>
  );
};

export default memo(AppLayout);
